function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import moment from 'moment';
import head from 'ramda/src/head';
import isNil from 'ramda/src/isNil';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import reject from 'ramda/src/reject';
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { fetchCodeTypes, fetchProductLineOfBusinessDeliveryCapability, fetchProductLineOfBusinessDeliveryCapabilityConfigurationAction } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { hasAccess, hasAdminAccess } from 'invision-core/src/components/security/permission.service';
import { MetadataCodeLoadedSelector, MetadataCodeSelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import CustomerLocaleKeys from '../../../../../locales/keys';
import { NOTIFICATION_TIME_LENGTH } from '../../../../../customercare.constants';
import { GRANT_ADDITIONAL_RIGHTS, ORDERING_ACCESS } from '../../../../../security.attributes';
import { CurrentCustomerIdSelector, RouteParams, RouteState } from '../../../../../reducers/selectors/customer.selectors';
import { ActiveProductSelector, CanViewContentActivitySelector, CustomerProductsCountSelector, CustomerRecentProductsCollectionSelector, IsRemovingProductSelector } from '../../../../../reducers/selectors/customer.products.selectors';
import { retrieveProducts, setActiveProduct } from '../../../../../reducers/actions/customer.products.actions';
import { RECENT_PRODUCTS_TO_DISPLAY } from '../../../../../reducers/constants/dashboard.constants';
import { CREATE_PRODUCTS_ORDER_STATE_NAME as ADD_PRODUCT_STATE } from '../../../../../reducers/constants/products.wizard.constants';
import { DETAIL_STATE_OR_NAME as CONTENT_ACTIVITY_STATE } from '../../../contentActivity/content.activity.config';
import { DETAIL_STATE_OR_NAME as PRODUCT_STATE } from '../../../products/products.config';
var ACTIVE_PRODUCT_IMAGE_WIDTH = 180;
var PRODUCT_IMAGE_WIDTH = 120;
var ProductsController = /*#__PURE__*/function () {
  function ProductsController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, ProductsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      customerCareKeys: CustomerLocaleKeys,
      uiNotificationService: uiNotificationService
    });
    this.closeRemoveProductsPopup = this.closeRemoveProductsPopup.bind(this);
    this.submitRemoveProductsPopup = this.submitRemoveProductsPopup.bind(this);
  }
  return _createClass(ProductsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          activeProduct: ActiveProductSelector(store),
          canViewContentActivity: CanViewContentActivitySelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          deliveryCapabilities: MetadataCodeSelector(CODES.ProductLineOfBusinessDeliveryCapability, store),
          deliveryCapabilitiesLoaded: MetadataCodeLoadedSelector(CODES.ProductLineOfBusinessDeliveryCapability, store),
          deliveryCapabilityConfigurationLoaded: MetadataCodeLoadedSelector(CODES.ProductLineOfBusinessDeliveryCapabilityConfigurationAction, store),
          isDbss: IsDbss(store),
          isRemovingProduct: IsRemovingProductSelector(store),
          productsCount: CustomerProductsCountSelector(store),
          recentProducts: CustomerRecentProductsCollectionSelector(store),
          routeParams: RouteParams(store),
          routeState: RouteState(store),
          structureTypes: MetadataCodeTypeSelector(CODES.StructureType, store),
          structureTypesLoaded: MetadataCodeLoadedSelector(CODES.StructureType, store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeType: fetchCodeTypes,
        fetchProductLineOfBusinessDeliveryCapability: fetchProductLineOfBusinessDeliveryCapability,
        fetchDeliveryCapabilityConfiguration: fetchProductLineOfBusinessDeliveryCapabilityConfigurationAction,
        retrieveProducts: retrieveProducts,
        setActiveProduct: setActiveProduct,
        stateGo: stateGo
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.activeProductImageWidth = ACTIVE_PRODUCT_IMAGE_WIDTH;
      this.productImageWidth = PRODUCT_IMAGE_WIDTH;
      this.currentDateTime = new Date();
      this.addProductAction = {
        id: 'ADD_PRODUCT',
        title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.ADD_PRODUCT),
        callback: function callback() {
          _this.goToAddProductWizard();
        },
        shouldShow: function shouldShow() {
          return _this.hasOrderingAccess();
        }
      };
      this.actionsList = [{
        id: 'PRODUCT_DETAILS',
        title: i18n.translate(CustomerLocaleKeys.VIEW_DETAILS),
        callback: function callback() {
          _this.goToProductDetails();
        },
        shouldShow: function shouldShow() {
          return hasAccess(_this.state.userSecurityAttributes, ORDERING_ACCESS);
        }
      }, {
        id: 'VIEWING_ACTIVITY',
        title: i18n.translate(CustomerLocaleKeys.VIEW_CONTENT_ACTIVITY),
        callback: function callback() {
          _this.goToProductContentActivity();
        },
        shouldShow: function shouldShow() {
          return _this.state.canViewContentActivity;
        }
      }, {
        id: 'REMOVE_PRODUCTS',
        title: i18n.translate(CustomerLocaleKeys.REMOVE_PRODUCTS.TITLE),
        callback: function callback() {
          _this.openRemoveProductsPopup();
        },
        shouldShow: function shouldShow() {
          return _this.hasOrderingAccess() && !(pathOr(false, ['Product', 'Standalone'], _this.state.activeProduct) && _this.state.isDbss);
        }
      }, {
        id: 'GRANT_ACCESS',
        title: i18n.translate(CustomerLocaleKeys.GRANT_ACCESS.GRANT_ACCESS),
        callback: function callback() {
          _this.openGrantAccessRightsPopup();
        },
        shouldShow: function shouldShow() {
          var expired = pathOr(null, ['activeProduct', 'Expired'], _this.state);
          return hasAccess(_this.state.userSecurityAttributes, GRANT_ADDITIONAL_RIGHTS) && expired;
        }
      }];
      if (!this.isContentActivityEnabled) {
        var updatedActionsList = this.actionsList.filter(function (item) {
          return item.id !== 'VIEWING_ACTIVITY';
        });
        this.actionsList = updatedActionsList;
      }
      if (this.hasWidgetAccess()) {
        if (!this.state.structureTypesLoaded) {
          this.actions.fetchCodeType(CODES.StructureType);
        }
        if (!this.state.deliveryCapabilitiesLoaded) {
          this.actions.fetchProductLineOfBusinessDeliveryCapability();
        }
        if (!this.state.deliveryCapabilityConfigurationLoaded) {
          this.actions.fetchDeliveryCapabilityConfiguration();
        }
        if (!isNil(this.state.currentCustomerId)) {
          this.getRecentProductsAndUpdate();
        }
      }
      this.grantAccessRightsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.grantAccessRightsPopupConfig = api;
        }
      };
      this.showGrantAccessModal = false;
      this.removeProductsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.removeProductsPopupConfig = api;
        }
      };
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.customerId && !isNil(this.state.currentCustomerId) && !changes.customerId.isFirstChange() && this.state && this.hasWidgetAccess()) {
        this.getRecentProductsAndUpdate();
      }
      if (this.state) {
        this.moreOptionsMenu = [this.addProductAction].filter(function (menuItem) {
          return menuItem.shouldShow();
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "submitGrantAccessRightsPopup",
    value: function submitGrantAccessRightsPopup() {
      this.closeGrantAccessRightsPopup();
      this.getRecentProductsAndUpdate();
      this.uiNotificationService.success(i18n.translate(this.customerCareKeys.GRANT_ACCESS.SUCCESSFULLY_UPDATED), null, {
        timeout: NOTIFICATION_TIME_LENGTH
      });
    }
  }, {
    key: "closeGrantAccessRightsPopup",
    value: function closeGrantAccessRightsPopup() {
      this.grantAccessRightsPopupConfig.close();
      this.showGrantAccessModal = false;
    }
  }, {
    key: "openGrantAccessRightsPopup",
    value: function openGrantAccessRightsPopup() {
      var _this2 = this;
      this.showGrantAccessModal = true;
      this.$timeout(function () {
        _this2.grantAccessRightsPopupConfig.open();
      });
    }
  }, {
    key: "getExpirationDate",
    value: function getExpirationDate(policies) {
      if (policies) {
        //this finds the expiration date from a list of purchase policies on a locker item
        var expirationDate = head(reject(isNil, pluck('ExpirationDate')(policies)));
        this.isExpired = moment(expirationDate).isBefore(moment());
        return expirationDate;
      }
    }
  }, {
    key: "getAssociatedCapability",
    value: function getAssociatedCapability(deliveryCapability) {
      var associatedCapability = this.state.deliveryCapabilities.items.find(function (capability) {
        return deliveryCapability && deliveryCapability.toString() === capability.Value;
      });
      return associatedCapability ? associatedCapability.Name : '';
    }
  }, {
    key: "getRecentProductsAndUpdate",
    value: function getRecentProductsAndUpdate() {
      var _this3 = this;
      this.actions.retrieveProducts(this.state.currentCustomerId, {
        IncludeEntitlementContext: true,
        IncludeExpired: true,
        PageSize: RECENT_PRODUCTS_TO_DISPLAY
      }).then(function () {
        _this3.updateCountAndActive();
      });
    }
  }, {
    key: "goToAddProductWizard",
    value: function goToAddProductWizard() {
      this.actions.stateGo(ADD_PRODUCT_STATE, {
        productsOnly: true
      });
    }
  }, {
    key: "goToProductContentActivity",
    value: function goToProductContentActivity() {
      this.actions.stateGo(CONTENT_ACTIVITY_STATE, {
        productId: this.state.activeProduct.Product.Id,
        previousRoute: {
          name: this.state.routeState.name,
          params: this.state.routeParams
        }
      }, {
        reload: true
      });
    }
  }, {
    key: "goToProductDetails",
    value: function goToProductDetails() {
      this.actions.stateGo(PRODUCT_STATE, {
        lockerItemId: this.state.activeProduct.Id
      });
    }
  }, {
    key: "hasOrderingAccess",
    value: function hasOrderingAccess() {
      return hasAdminAccess(this.state.userSecurityAttributes, ORDERING_ACCESS);
    }
  }, {
    key: "submitRemoveProductsPopup",
    value: function submitRemoveProductsPopup() {
      this.closeRemoveProductsPopup();
      this.getRecentProductsAndUpdate();
    }
  }, {
    key: "showAvailabilityDate",
    value: function showAvailabilityDate() {
      return new Date(pathOr(null, ['PricingPlan', 'AvailabilityStart'], this.state.activeProduct)) > this.currentDateTime;
    }
  }, {
    key: "closeRemoveProductsPopup",
    value: function closeRemoveProductsPopup() {
      this.removeProductsPopupConfig.close();
      this.showRemoveProductsPopup = false;
    }
  }, {
    key: "hasWidgetAccess",
    value: function hasWidgetAccess() {
      return hasAccess(this.state.userSecurityAttributes, ORDERING_ACCESS);
    }
  }, {
    key: "openRemoveProductsPopup",
    value: function openRemoveProductsPopup() {
      var _this4 = this;
      this.showRemoveProductsPopup = true;
      this.$timeout(function () {
        _this4.removeProductsPopupConfig.open();
      });
    }
  }, {
    key: "onMenuItemSelected",
    value: function onMenuItemSelected(selected) {
      return selected.item.callback();
    }
  }, {
    key: "setActiveProduct",
    value: function setActiveProduct(product) {
      this.actions.setActiveProduct(product);
    }
  }, {
    key: "updateCountAndActive",
    value: function updateCountAndActive() {
      this.state.activeProduct = this.state.recentProducts[0];
      this.setActiveProduct(this.state.activeProduct);
      this.viewAllText = i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.VIEW_ALL_PRODUCTS, {
        count: this.state.productsCount
      });
    }
  }]);
}();
export default {
  template: require('./products.html'),
  controller: ProductsController,
  controllerAs: 'Products',
  bindings: {
    isContentActivityEnabled: '<?'
  }
};